var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54199 47.2827C3.71172 55.3333 8.4937 62.311 14.9241 67.2518V47.2827H1.54199Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4893 74.8574C35.5642 74.95 36.6512 75 37.7501 75C55.0762 75 69.6552 63.2489 73.9583 47.2827H34.4893V74.8574Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9583 27.7173C69.6552 11.7511 55.0762 0 37.7501 0C36.6512 0 35.5642 0.0500977 34.4893 0.142676V27.7173H73.9583Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9241 7.74829C8.4937 12.6892 3.71172 19.6667 1.54199 27.7173H14.9241V7.74829Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9326 32.6087H29.598H29.5979V0.891357C26.1323 1.65981 22.8468 2.90537 19.8152 4.55962V32.6084V32.6086H0.567432C0.358691 34.2098 0.25 35.8422 0.25 37.5C0.25 39.1578 0.358691 40.7902 0.567432 42.3913H19.815H19.8152V70.4402C22.8468 72.0943 26.1323 73.3402 29.5979 74.1085V42.3917V42.3914H74.9326C75.141 40.7902 75.25 39.1578 75.25 37.5C75.25 35.8422 75.141 34.2098 74.9326 32.6087Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagNorway);
export default __webpack_public_path__ + "static/media/flagNorway.d2efaf4487ba144ac73c7872fff1d490.svg";
export { ForwardRef as ReactComponent };